<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let edt of controls; let i = index">
    <div class="edt-container-fields">
      <mat-form-field>
        <input
          matInput
          placeholder="Nome (EDTN)"
          formControlName="EDTN">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Data (aaaa?-mm?-gg) (EDTD)"
          formControlName="EDTD">
        <mat-error *ngIf="edt?.controls.EDTD?.hasError('iccdDate')">
          {{ 'Formato data non conforme allo standard ICCD' | translate }}
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Luogo (EDTL)"
          formControlName="EDTL">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="(EDTE)"
          formControlName="EDTE">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="(EDTR)"
          formControlName="EDTR">
      </mat-form-field>

      <button
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi editore' | translate }}
  </button>
</div>
